import { useReducedMotion as useMotionReducedMotion } from 'motion/react';

export const DURATION = 0.14;
export const PAGE_DURATION = 0.09;
export const TAB_PAGE_DURATION = 0.07;
export const FAST_DURATION = 0.1;
export const EASE = [0.25, 0.1, 0.25, 1] as const;
export const PRESS_SCALE = 0.97;

export const PAGE_TRANSITION = {
	duration: PAGE_DURATION,
	ease: EASE,
};

export const TAB_PAGE_TRANSITION = {
	duration: TAB_PAGE_DURATION,
	ease: EASE,
};

export const PRESS_TRANSITION = {
	type: 'spring' as const,
	stiffness: 550,
	damping: 32,
};

export const FADE_TRANSITION = {
	duration: DURATION,
	ease: EASE,
};

export function useReducedMotion(): boolean {
	return useMotionReducedMotion() ?? false;
}
